import { createContext, useContext } from "react";
import { useSpace } from "./SpaceContext";
import { useUploader } from "@/hooks/useUploader";

// Direct uploads live above the routes so they keep going (and stay listed) while browsing
const Ctx = createContext(null);

export const UploaderProvider = ({ children }) => {
  const { bump } = useSpace();
  return <Ctx.Provider value={useUploader(bump)}>{children}</Ctx.Provider>;
};

export const useUploads = () => useContext(Ctx);
